export const WITHDRAWALLIST = {
  partners: {
    nuanwa: {
      name: '暖哇',
      probability: 90,
      slots: {
        withdrawal_pop: {
          ads: {
            WITHDRAWAL_POP: {
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/assets/info/output-with.png'),
              eventName: 'Jump-to-withdrawal-list-nuamwa',
              content: `{"key":"提现筹款列表弹窗","partners":"暖哇"}`,
              jumpUrl: 'https://m.aibangbaoxian.net/wxAppBusiness?shuntCode=AB2025072502',
              partners: '暖哇',
              probability: 100,
            },
          },
        },
      },
    },
    yixin:{
      name: '毅新',
      probability: 5,
      slots: {
        withdrawal_pop: {
          ads: {
            WITHDRAWAL_POP: {
              isWatch:false,
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/config/assets/yixin/withdrawalList/output-with.png'),
              eventName: 'Jump-to-withdrawal-list-yixin',
              content: `{"key":"提现筹款列表弹窗","partners":"毅新"}`,
              jumpUrl: 'https://item.jd.com/10168369141526.html?extension_id=eyJhZCI6IjI2OCIsImNoIjoiMiIsInNrdSI6IjEwMTY4MzY5MTQxNTI2IiwidHMiOiIxNzgxNTg3NTk5IiwidW5pcWlkIjoie1wiY2xpY2tfaWRcIjpcImRiN2NjNDJiLWQxYWEtNGUxZS04NzRkLWIxZDQ2MjkwOTgxNVwiLFwibWF0ZXJpYWxfaWRcIjpcIjU0NDA1MjAwMTYzXCIsXCJwb3NfaWRcIjpcIjI2OFwiLFwic2lkXCI6XCI1YzQyYTJkZC0xYzFmLTQ1NDEtYjZkNi1lNzU3M2Y1NWMwMzlcIn0ifQ==&jd_pop=db7cc42b-d1aa-4e1e-874d-b1d462909815&abt=0',
              partners: '毅新',
              probability: 100,
            },
          },
        },
      },
    },
    haohai:{
      name: '浩海',
      probability: 5,
      slots: {
        withdrawal_pop: {
          ads: {
            WITHDRAWAL_POP: {
              isWatch:false,
              id: 'WITHDRAWAL_POP_ADS_A',
              imgUrl: require('@/config/assets/haohai/withdrawalList/output-with.png'),
              eventName: 'Jump-to-withdrawal-list-haohai',
              content: `{"key":"提现筹款列表弹窗","partners":"浩海"}`,
              jumpUrl: '',
              partners: '浩海',
              probability: 100,
            },
          },
        },
      },
    }
  },
}

export const withdrawalListPageData = ['Jump-to-withdrawal-list-yixin','Jump-to-withdrawal-list-haohai']
